import React from "react"
import Paper from "material-ui/Paper"
import { grey200, white, pink400 } from "material-ui/styles/colors"
import { Flex, Box, Card, BackgroundImage, Text } from "rebass"
import { Currency } from "../../components"
import { CLIENT_URL } from "../../restClient"

const DefaultImage =
  "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/product/ola-logo-I2C.png"

const ProductCard = ({ product, itemWidth }) => {
  //const image = product.photos ? product.photos[0] : product.photo;
  var image = DefaultImage
  if (product.photos && product.photos !== null) {
    if (Array.isArray(product.photos) && product.photos.length > 0) {
      image = product.photos[0]
    } else {
      if ("*" in product.photos && product.photos["*"].photos.length > 0) {
        image = product.photos["*"].photos[0]
      } else if ("photo_set" in product.photos) {
        var keys = Object.keys(product.photos.photo_set)
        for (var i = 0; i < keys.length; i++) {
          if (
            product.photos.photo_set[keys[i]].photos &&
            product.photos.photo_set[keys[i]].photos.length > 0
          ) {
            image = product.photos.photo_set[keys[0]].photos[0]
            break
          }
        }
      }
    }
  }
  const { price, margin, discount, name } = product
  const discountedPrice =
    discount < 1 ? price * (1 - discount) : price - discount
  const newMargin = margin && margin < 1 ? discountedPrice * margin : margin

  return (
    <Paper zDepth={1} style={{ backgroundColor: "#eeeeee", width: itemWidth }}>
      <Card>
        <a href={`${CLIENT_URL}/${product.slug}`} target={"_blank"}>
          <BackgroundImage src={image} ratio={1} />
        </a>
        <CardBox p={[1]} pb={[2]}>
          <Flex w={[1]} column>
            <Flex w={[1]}>
              <Text py={[1]} className="ql-font-Montserrat">
                {name}
              </Text>
            </Flex>
            <Flex
              w={[1]}
              direction={["row"]}
              justify={["space-between"]}
              className="ql-font-OpenSans"
            >
              <Text py={[1]}>Harga</Text>
              <Text py={[1]}>
                <Currency value={discountedPrice} />
              </Text>
            </Flex>
            <Flex
              w={[1]}
              direction={["row"]}
              justify={["space-between"]}
              p={[1]}
              style={{ backgroundColor: pink400, color: white }}
              className="ql-font-OpenSans"
            >
              <Text>Komisi</Text>
              <Text>
                <Currency value={newMargin} colorText={white} />
              </Text>
            </Flex>
          </Flex>
        </CardBox>
      </Card>
    </Paper>
  )
}

const CardBox = Box.extend`
  background-color: ${grey200};
`

export default ProductCard



// WEBPACK FOOTER //
// ./src/campaigns/productlist/ProductCard.js